import { useEffect } from 'react';
import { eventBus } from '@atc/cai-event-bus';
import { UDS_PENCILING_DATA_UPDATED } from 'wallet-manager';
const usePencillingDataUpdate = (pencilingEventData, udsLocalStateValues) => {
  const {
    activeTab,
    initialDealType,
    offerPrice,
    localPrice,
    financeDownPayment,
    leaseDownPayment,
    obfuscatedCredit,
    selectedLoanTerm,
    selectedLeaseTerm
  } = udsLocalStateValues || {};
  useEffect(() => {
    const pencilingData = {
      offerPrice: offerPrice ?? localPrice,
      downPayment: activeTab === 'lease' ? leaseDownPayment : financeDownPayment,
      creditTier: obfuscatedCredit,
      term: activeTab === 'lease' ? selectedLeaseTerm : selectedLoanTerm,
      dealType: activeTab ?? initialDealType
    };
    eventBus.emit(UDS_PENCILING_DATA_UPDATED, pencilingData);
  }, [activeTab, financeDownPayment, selectedLeaseTerm, selectedLoanTerm, obfuscatedCredit, offerPrice,
  // eslint-disable-next-line react-hooks/exhaustive-deps
  JSON.stringify(pencilingEventData), localPrice, initialDealType, leaseDownPayment]);
};
export { usePencillingDataUpdate as default };
